import { Parser } from 'expr-eval';

const BlockView = require('views/block/base-block-view');
const AhoyService = require('services/ahoy-service');
const LocaleService = require('services/locale-service');


const CalculationView = BlockView.extend({
  className: 'calculation',
  initialize: function() {
    if(this.model.get('expression')) {
      this.expression  = this.model.get('expression');
      if(this.model.get('variables')) {
        this.variables = this.model.get('variables');
        // providing a scope for variables to be utilized by 'mathjs'
        // for evaluating variables in a given expression
        this.scope = {};
      }
      this.precision = this.model.get('precision');
    }
    this.callToAction = this.model.get('call_to_action');
    this.preventRound = this.model.get('prevent_rounding');
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
    this.subscribeEvent('block:values:change', (value, blockView, pageView) => {
      if(this.expression) {
        if(this.variables) {
          this._setExpressionVariables(value);
        }
      }
      this._setResult(value, blockView, pageView);
      AhoyService.track('calculation', {action: 'update', result: this.model.get('result')});
      this.$el.parent().hide().show(0);  // force repaint
      this.reRender();
    });
  },
  play: function() {
    if(this.model.get('updateOnLoad')) {
      if(!this.expression) {
        // Handling calculation at Page Level JS
        this.model.set('result', this.script[this.model.get('exec')]());
        this._decorateResult();
      }
      this.reRender();
    }
    this.readyToGo();
  },
  _setExpressionVariables: function(value) {
    this.variables.forEach(variable => {
      if($(`#${variable}`)[0]){
        this.scope[variable] = $(`#${variable}`)[0].value;
      }else if(value && (value[variable] || value.id === variable)){
          this.scope[variable] = value[variable] || value.value;      
      }
    });
  },
  _setResult: function(value, blockView, pageView) {
    if(this.callToAction) {
      if(this.callToAction === value.id) {
        this._setResultByContext(value, blockView, pageView);
        this._decorateResult();
        this._showAlert();
      }
    } else {
      this._setResultByContext(value, blockView, pageView);
      this._decorateResult();
      this._showAlert();

    }
  },
  _showAlert: function() {
    const alertType = 'informational';
    const alertTitle = this.model.get('sr_text') ? this.model.get('sr_text') : LocaleService.t('Result') + ' ' + this.model.get('result');
    const icon = '';
    const visibility = this.model.get('show_alert') || false;
    const alertMsg = '';
    Chaplin.mediator.publish('action:alert', alertType, alertTitle, alertMsg, icon, visibility);
  },

  _setResultByContext: function(value, blockView, pageView) {
    if(this.expression) {
      let result;

      if(this.variables) {
        result = Parser.evaluate(this.expression, this.scope);
      } else {
        result = Parser.evaluate(this.expression);
      }

      if(!this.preventRound) {
        result = Math.round(result);
      }

      if(!this._isInteger(result) && this.precision) {
        result = result.toFixed(this.precision);
      }

      this.model.set('result', result.toLocaleString());
    } else {
      this.model.set('result', this.script[this.model.get('exec')](value, blockView, pageView));
    }
  },
  _decorateResult: function() {
    if(this.model.get('result_prefix')) {
      this.model.set('result', `${this.model.get('result_prefix')}${this.model.get('result')}`);
    }
    if(this.model.get('result_postfix')) {
      this.model.set('result', `${this.model.get('result')}${this.model.get('result_postfix')}`);
    }
  },
  _isInteger: function(value) {
    let isInteger;

    if(Number.isInteger) {
      isInteger = Number.isInteger(value);
    } else {
      isInteger = typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    }

    return isInteger;
  }
});

module.exports = CalculationView;
